// Route names of the adviser enrolment pages (/adviser plus the channel
// pages). Everywhere the app special-cases the adviser page — navbar choice,
// standalone layout, banner suppression — must treat these identically.
export const adviserEnrolmentRouteNames = [
  'AdviserEnrolment',
  'MfcAdviserEnrolment',
  'IfaAdviserEnrolment',
  'PfaAdviserEnrolment',
  'AdviserFaqs',
  'AdviserResources',
];

export function redesign() {
  switch (process.env.VUE_APP_BRAND) {
    case 'oldmutual':
    case 'teba':
      return true;
    case 'quickwill':
      return false;
    default:
      false;
  }
}

export function landingPages() {
  switch (process.env.VUE_APP_BRAND) {
    case 'oldmutual':
      return true;
    case 'teba':
    case 'quickwill':
      return false;
    default:
      false;
  }
}
